module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_0.de3ee42d.png";